import { z } from 'zod';

/**
 * Health check response schema and type.
 */
export const HealthCheckResponseSchema = z.object({
  status: z.enum(['healthy', 'degraded', 'unhealthy']),
  timestamp: z.string().datetime(),
  version: z.string(),
  database: z.object({
    connected: z.boolean(),
    latencyMs: z.number().optional(),
  }),
});

export type HealthCheckResponse = z.infer<typeof HealthCheckResponseSchema>;

/**
 * Generic API error response.
 */
export const ApiErrorResponseSchema = z.object({
  code: z.string(),
  message: z.string(),
  details: z.record(z.unknown()).optional(),
});

export type ApiErrorResponse = z.infer<typeof ApiErrorResponseSchema>;

/**
 * Connection status for frontend tracking.
 */
export type ConnectionStatus = 'connecting' | 'connected' | 'disconnected' | 'error';
